// The purchase-order number a person actually reads: printed on the PO email
// that goes to the supplier, and shown on the archive row in the CRM.
//
// It lives in contracts, not in the command that sends the email, because the
// archive and the email must print the SAME string. Two implementations of a
// customer-visible identifier is how the office ends up holding two names for
// one order — and the divergence would be silent, because both look right on
// their own.
//
// The narrow signature is deliberate: contracts must not import PoReview, and
// `services/api` must not depend on `@aiw/commands` (that would drag the pricing
// engine in for one string). Anything carrying a po_id and a version qualifies.
/** Jacky, 13 Oct 2026: "use something like PO-JXXXXX <-- job #, can keep the Version control, but unless PO changed after
 *  first submit, its always V1 to supplier". Draft edits move `version`, never the supplier's number. */
export function poOrderNumber(po) {
    if (po.order_ref)
        return `${po.order_ref}-V${po.supplier_version ?? 1}`;
    return `AIW-${po.po_id.replaceAll('-', '').slice(0, 12).toUpperCase()}-V${po.version}`;
}
/** The readable number's base: the order's Job (or its first line's Job) and the supplier's short code.
 *  PO-J0926-10217-GHC; no Job → PO-STOCK-<yymmdd Sydney>-GHC. A repeat for the same base gets "-2", "-3". */
export function orderRefBase(jobRef, supplierCode, sydneyDay) {
    const code = supplierCode.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 6) || 'SUP';
    return jobRef ? `PO-${jobRef.replace(/^J-?/, 'J')}-${code}` : `PO-STOCK-${sydneyDay.slice(2).replaceAll('-', '')}-${code}`;
}
/** The supplier email's body: the sender's words, then the fixed attachment line. One definition, so the
 *  CRM's preview before the click and the email EmmA's worker sends cannot say different things. */
export function poEmailBody(po, message) {
    return `${message}\n\nPurchase order ${poOrderNumber(po)} is attached.\n\nArtemis Flooring\nApproved by the Artemis Flooring team.`;
}
//# sourceMappingURL=po-order-number.js.map